import { useQueryClient } from "@tanstack/react-query";
import { createPositionType, updatePositionType } from "@/Services/institutions.service";
import type { InstitutionScope } from "../types";

export function useInstitutionPositionTypeMutations(institutionId: string) {
  const queryClient = useQueryClient();

  const invalidate = () =>
    queryClient.invalidateQueries({ queryKey: ["institution-position-types", institutionId] });

  async function create(payload: { name: string; scope: InstitutionScope; sort_order: number }, userId: string) {
    const result = await createPositionType(institutionId, payload, userId);
    await invalidate();
    return result;
  }

  async function update(id: string, updates: Parameters<typeof updatePositionType>[1]) {
    const result = await updatePositionType(id, updates);
    await invalidate();
    return result;
  }

  return { create, update };
}
